import useSWR from "swr";
import axios from "axios";
import { fetcher } from "../components/Overview/Overview";
import { useDebounce } from "../utils/debounce";
import {appendSearchParams} from "../utils/urls";

// Function which fetches results from the server using SWR)
export function getCourses(stateToDebounce) {
    const state = useDebounce(stateToDebounce, 300);

    const params = new URLSearchParams({
        offset: state.offset,
        is_editable: true,
        limit: state.size,
        ordering: (state?.ordering?.direction || "") + (state?.ordering?.columnIdentifier || "your_reference"),
    });
    if (state?.filter) {
        appendSearchParams(params, state.filter);
    }

    // if (state?.identifier) {
    //     // console.info([...params.entries()]);
    //     console.info(params.toString());
    // }

    // Use SWR accepts both an url or a function as its first param.
    // When passing an url it uses the URL as a cache key, fetches the result, and stores it for the default amount of time
    // When passing a function, the function can evaluate vars before returning the URL. This is useful for 2 checking
    // if required params or dependencies are set. When a falsy result is returned it is handled as a non-call
    // Please note: as SWR is a Hook, it should always return the same result (even if something is wrong!)
    // Therefore, you can not just return false to the one calling getCourses
    return useSWR(
        () => (state?.identifier ? `/v1/courses/?${params.toString()}` : false),
        fetcher
    );
}

export async function remoteSetCompetenceProfile(courseUUID, competenceProfileUUID) {
    if (courseUUID !== undefined) {
        return await axios.patch(`/v1/courses/${courseUUID}/`, {
            competence_profile: competenceProfileUUID
        });
    }
}

export async function remoteSaveCourseDetails(courseUUID = false, data) {
    let result = null;
    let errors = [];

    if (!courseUUID) {
        result = await axios
            .post("/v1/courses/", data)
            .then((result) => result.data)
            .catch((error) => {
                if (error.response) {
                    for (const [field, error] of Object.entries(error.response.data)) {
                        errors.push({ field: field, error: error[0] });
                    }
                }
            });
    } else {
        result = await axios
            .patch(`/v1/courses/${courseUUID}/`, data)
            .then((result) => result.data)
            .catch((error) => {
                if (error.response) {
                    for (const [field, error] of Object.entries(error.response.data)) {
                        errors.push({ field: field, error: error[0] });
                    }
                }
            });
    }
    // axios[type]("//url/bla");

    return {
        result,
        errors
    };
}

export async function remoteSetCourseUserOptions(courseUUID, options = []) {
    const url = `/v1/courses/${courseUUID}/`;

    const result = await axios
        .patch(url, {
            student_options: options
                .filter((option) => option?.userUUID && option?.name !== "" && option?.value !== undefined)
                .map((option) => {
                    return {
                        user: option?.userUUID,
                        [option.name]: option.value
                    };
                })
        })
        .then((result) => result.data);

    return result;
}
